import { render, staticRenderFns } from "./EditarValorTotal.vue?vue&type=template&id=610375fc&"
import script from "./EditarValorTotal.vue?vue&type=script&lang=js&"
export * from "./EditarValorTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports